export enum AsyncStatus {
  Void = 'void',
  Pending = 'pending',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
}
